import React from 'react';
import { T } from '@colonist/ui';
import styles from './SettingTab.module.scss';
export const SettingTab = ({ icon, label, onClick })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.settingTabContainer,
        onClick: onClick
    }, /*#__PURE__*/ React.createElement("img", {
        src: icon,
        className: styles.icon
    }), /*#__PURE__*/ React.createElement(T, {
        id: label
    }));
};
